import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';

export function addCustomAvailability(values, callBack) {
    return function () {
        Client.post(URL.IM_EDUCATOR.CUSTOM_AVAILABILITY, values, true)
            .then((response) => {
                myLog('====addAvailability response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====addAvailability error===????', error);
                callBack(false);
            });
    };
}

export function editCustomAvailability(availableId, values, callBack) {
    return function () {
        Client.put(
            `${URL.IM_EDUCATOR.CUSTOM_AVAILABILITY}?availableId=${availableId}`,
            values,
            true
        )
            .then((response) => {
                myLog('====addAvailability response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====addAvailability error===????', error);
                callBack(false);
            });
    };
}

export function deleteCustomAvail(scheduleId, callBack) {
    return function () {
        Client.DELETE(`${URL.IM_EDUCATOR.AVAILABILITY}/${scheduleId}`, null, true)
            .then((response) => {
                myLog('====deleteAvail response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====deleteAvail error===????', error);
                callBack(false);
            });
    };
}

export function getCustomAvailList(values, callBack) {
    return function () {
        Client.get(URL.IM_EDUCATOR.CUSTOM_AVAILABILITY, values, true)
            .then((response) => {
                callBack(response.response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
}
